import { RichText } from '@payloadcms/richtext-lexical/react'
import Image from 'next/image'
import React from 'react'

import { getMediaUrl } from '@/lib/media'
import type { Media, Page } from '@/payload-types'

type PageSection = NonNullable<Page['sections']>[number]

export function SectionContent({ section }: { section: PageSection }) {
  const iconUrl = getMediaUrl(section.titleIcon)
  const images = section.images ?? []

  return (
    <div id={section.sectionId} className="scroll-mt-24">
      <div className="mb-6 flex items-center gap-3">
        {iconUrl ? (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center">
            <Image src={iconUrl} alt="" width={20} height={20} aria-hidden />
          </span>
        ) : null}
        <h2 className="font-bebas-neue text-2xl font-normal uppercase tracking-wide text-[#1a1a1a]">
          {section.sectionTitle}
        </h2>
      </div>
      {section.sectionContent && (
        <div className="payload-richtext font-poppins mb-6 text-base leading-relaxed [&_.payload-richtext]:p-0 [&_.payload-richtext]:font-poppins [&_.payload-richtext]:text-inherit [&_.payload-richtext]:leading-relaxed [&_.payload-richtext]:text-base [&_ul]:ml-4 [&_ul]:!list-disc [&_ul]:pl-2 [&_ul]:space-y-1 [&_ul]:font-poppins [&_ol]:ml-4 [&_ol]:!list-decimal [&_ol]:pl-2 [&_ol]:space-y-1 [&_ol]:font-poppins [&_li]:mt-0.5 [&_li]:font-poppins [&_p]:font-poppins">
          <RichText data={section.sectionContent} />
        </div>
      )}
      {images.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-4">
          {images.map((img, i) => {
            const media = typeof img === 'object' ? img : null
            const url = media ? getMediaUrl(media) : null
            if (!url) return null
            return (
              <div
                key={i}
                className="relative aspect-video w-full max-w-md overflow-hidden rounded-lg bg-neutral-200"
              >
                <Image
                  src={url}
                  alt={(media as Media)?.alt ?? ''}
                  fill
                  className="object-cover"
                  sizes="(max-width: 768px) 100vw, 28rem"
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
